import React, { Component } from 'react';
import './../App.css';
import Logo from './../images/translogo.png';
import {Link} from 'react-router-dom';
import { FaMoon, FaSun} from "react-icons/fa";
export default class Navbar extends Component{
    state={
        darkTheme:true
    }



    changeTheme = e =>{
        this.setState({
            darkTheme:!this.state.darkTheme
        })
        this.state.darkTheme ? document.body.classList.add('dark-theme') : document.body.classList.remove('dark-theme')
      
    }
    render(){
        return(
            <nav>
                <div className='container'>
                    <div className='nav-container'>
                        <div className='logo'>
                            <Link to='/' className='navbar-brand'>
                                <img src={Logo} alt='Mostafa abdelaziem Hero Logo'/>
                                <span className='beta'>Beta</span>
                            </Link>
                        </div>
                        <div className='menu-container'>
                            <ul>
                                <li>
                                    <Link to='/' >Home</Link>
                                </li>
                                <li>
                                    <Link to='/about'>About</Link>
                                </li>
                                <li>
                                    <Link to='/Experience'>Experience</Link>
                                </li>
                                <li>
                                    <Link to='/recentworks'>recent work</Link>
                                </li>
                               
                                {/* <li>
                                    <Link to='/services'>services</Link>
                                </li> */}
                                {/* <li>
                                    <Link to='/shop'>shop</Link>
                                </li> */}
                                <li onClick={this.changeTheme}>
                                    
                                {
                                    document.body.classList.contains('dark-theme') ?  <FaMoon/> : <FaSun/>

                                }
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </nav>
        )
    }
}